import { API_BASE_URL } from '../services/api/client';

/** Canonical SPA path for bundled provider/model icons under public/. */
const CATALOG_ICON_PREFIX = '/images/models/providers/';

function getApiOrigin() {
  if (API_BASE_URL === '/api') {
    return typeof window !== 'undefined' ? window.location.origin : '';
  }
  try {
    return new URL(API_BASE_URL).origin;
  } catch {
    return '';
  }
}

/**
 * Normalize legacy catalog icon paths to files under public/images/models/providers/.
 * DB rows may still store /provider-icons/ or /providers/ from older syncs.
 */
function normalizeCatalogIconPath(pathname) {
  if (!pathname) return pathname;
  if (pathname.startsWith('/provider-icons/')) {
    return `${CATALOG_ICON_PREFIX}${pathname.slice('/provider-icons/'.length)}`;
  }
  if (pathname.startsWith('/providers/')) {
    return `${CATALOG_ICON_PREFIX}${pathname.slice('/providers/'.length)}`;
  }
  return pathname;
}

function isCatalogStaticPath(pathname) {
  const normalized = normalizeCatalogIconPath(pathname);
  return (
    normalized.startsWith('/images/models/') ||
    pathname.startsWith('/provider-icons/') ||
    pathname.startsWith('/providers/')
  );
}

/**
 * Resolve catalog model/provider icon paths for <img src> / Avatar.
 * Bundled assets live under `public/images/models/` (and legacy prefixes). Full https URLs pass through.
 */
export function resolveModelIconUrl(icon) {
  if (!icon) return undefined;
  const s = String(icon).trim();
  if (!s) return undefined;

  if (s.startsWith('data:')) return s;

  if (s.startsWith('http://') || s.startsWith('https://')) {
    if (typeof window !== 'undefined') {
      try {
        const u = new URL(s);
        const apiOrigin = getApiOrigin();
        if (apiOrigin && u.origin === apiOrigin && isCatalogStaticPath(u.pathname)) {
          const path = normalizeCatalogIconPath(u.pathname);
          return `${window.location.origin}${path}${u.search}${u.hash}`;
        }
      } catch {
        /* ignore */
      }
    }
    return s;
  }

  if (s.startsWith('//')) {
    if (typeof window !== 'undefined') {
      return `${window.location.protocol}${s}`;
    }
    return `https:${s}`;
  }

  if (typeof window !== 'undefined') {
    const withSlash = s.startsWith('/') ? s : `/${s}`;
    if (
      withSlash.startsWith('/images/models/') ||
      withSlash.startsWith('/provider-icons/') ||
      withSlash.startsWith('/providers/')
    ) {
      const path = normalizeCatalogIconPath(withSlash);
      return `${window.location.origin}${path}`;
    }
  }

  return undefined;
}
